// extracted by mini-css-extract-plugin
module.exports = {"backgroundContainer":"styles_backgroundContainer__1BQR5","additionalContainer":"styles_additionalContainer__29jvq","swipeThing":"styles_swipeThing__1_B3T"};